// extracted by css-extract-rspack-plugin
export default {"pancakeIcon":"GlobalNavMenuToggle-module__pancakeIcon__dE2fg"};